export const formatPods = (replicas, available) =>
  replicas != null && available != null
    ? `[ ${replicas} of ${available} pods ]`
    : null;